
<div class="background page">
    <div class="inset" >
      
      
       <div >  
           <div *ngIf="org">
          <h3>Church Information</h3>
          <mat-form-field mat-error>
            <mat-label>Church Name</mat-label>
            <input 
                disabled="true"
                matInput 
                id="name" 
                class="short" 
                name="name" 
                type="text" 
                [ngModel]="org.name"><br/>
          </mat-form-field>
           <mat-form-field >
          <input matInput
            disabled="true"
            id="csphone"
            class="short"
            name="xcphone"
            type="tel"
            placeholder="Church Phone" [ngModel]="org.phone">
          </mat-form-field> 
        <mat-form-field> 
          <input
            disabled="true"
            matInput 
            id="code"
            class="short"
            name="code"
            type="text"
            placeholder="Church Short Name" [ngModel]="org.entityId"><br/>
        </mat-form-field> 
        <mat-form-field> 
          <input  disabled="true" matInput id="email-church" class="short" name="email-church" type="email" placeholder="Church Email" [ngModel]="org.email"><br/>
        </mat-form-field> 
        <mat-form-field> 
          <input  disabled="true" matInput id="address" class="short" name="address" type="text" placeholder="Address" [ngModel]="org.address"><br/>
        </mat-form-field> 
        

      
      <mat-form-field> 
          <input   disabled="true" matInput id="si-city" class="short" name="city" type="text" placeholder="City" [ngModel]="org.city"><br/>
      </mat-form-field> 
        <mat-form-field> 
          <input  disabled="true" matInput id="si-country" class="short" name="country" type="text" placeholder="Country" [ngModel]="org.country"><br/><br/>
        </mat-form-field> 
    </div>
 
        <div *ngIf="org?.pastor">
      <h3>Pastor's Information</h3>
      <mat-form-field mat-error>
      <input
        disabled="true"
        matInput 
        *ngIf="!!org?.pastor" 
        id="'pastor'" 
        class="short" 
        name="'pastor'" 
        type="text" 
        placeholder="Name" 
        [ngModel]="org.pastor.name"
        >
      </mat-form-field>
      <mat-form-field> 
          <input 
            disabled="true"
            matInput *ngIf='!!org?.pastor' id="fwephone" class="short" name="phone" type="tel" placeholder="Phone" [ngModel]="org.pastor.phone"><br/>
      </mat-form-field> 
   <mat-form-field> 
          <input 
            disabled="true"
            matInput *ngIf='!!org?.pastor' id="email" class="short" name="email" type="email" placeholder="Email " [ngModel]="org.pastor.email"><br/>
      </mat-form-field> 
    </div> 
            <!-- <div class="alert hideMessage" [ngClass]="{showMessage : verificationMessage, hideMessage:!verificationMessage}">
                <span class="closxpebtn" (click)="hideSuccessMessage()">&times;</span> 
                <strong>¡Envidado!</strong> Nos pondremos en contacto con usted.
              </div>
            <div class="errorAlert hideMessage" [ngClass]="{showMessage : errorMessage, hideMessage:!errorMessage}">
                <span class="closebtn" (click)="hideErrorMessage()">&times;</span> 
                <strong>{{errorMessage}}</strong> 
              </div>
  
          <button class="buttonConfig">Enviar</button>
          <div style="width: 100%; height: 0; padding-bottom: 50%"></div> -->
            </div>
    </div>
  </div>